import {interval, Subject} from 'rxjs';
import { throttle } from 'rxjs/operators';
import 'admin-lte/plugins/datatables-rowreorder/js/dataTables.rowReorder';

const RowReorder = $.fn?.dataTable?.RowReorder;

if (!RowReorder) {
    console.error('DataTables RowReorder plugin not found; reorderExtension disabled.');
} else {
    const order = RowReorder;

    const _cachePositions = order.prototype._cachePositions;
    const _mouseDown = order.prototype._mouseDown;


    order.prototype._findTables = function (){
        let table = $(this.s.dt.table().node());
        this.s.type = table.data('table-type');
        this.s.tables = $('.'+this.s.type+'-table:not(.dt-rowReorder-float)');
    }

    order.prototype._cachePositions = function (bodyY = null){

        this._findTables();

        if(bodyY !== null){
            let possibleTables = [];
            for(let i=0;i<this.s.tables.length;++i){

                let table = $(this.s.tables[i]);
                let top = table.offset().top;
                let bottom = top + table.height();

                if(bodyY >  top && bodyY < bottom){
                    possibleTables.push(table);
                    //this.dom.dtScroll = $('div.dataTables_scrollBody', this.s.dt.table().container())
                }
            }

            if(possibleTables.length == 0){
                return;
            }

            let table = possibleTables[0];
            let p = table.parents().length;

            if(possibleTables.length > 1){
                for(let i=1;i<possibleTables.length;++i){
                    let newP = possibleTables[i].parents().length;
                    if(newP > p){
                        table = possibleTables[i];
                        p = newP;
                    }
                }
            }

            let top = table.offset().top;
            console.log(table.attr('id'));
            let bottom = top + table.height();

            this.s.bodyTop = top;
            this.s.bodyBottom = bottom;
            this.s.dt = table.DataTable();


        }else{
            let cur = $(this.s.dt.table().node())
            this.s.bodyTop = cur.offset().top;
            this.s.bodyBottom = cur.height();
        }




        _cachePositions.call(this);

    }

    order.prototype._mouseDown = function (e, target){

        let startTable = target.parents('table').attr('id');
        this.dt = $('#'+startTable).DataTable();
        this.s.start.table = this.dt;
        this.s.moveObserver = new Subject();

        this.s.moveObserver
            .pipe(throttle(e => interval(500)))
            .subscribe(pos => {
                this._cachePositions(pos.y);

            });


        console.log(startTable);
        _mouseDown.call(this,e,target);


        this._findTables();
        // this.s.dt = $(this.s.tables[0]).DataTable();

        // console.log('start table',this.s.dt.table().node());
    }

    order.prototype._mouseMove = function (e){
        this._clonePosition( e );

        this.s.moveObserver?.next({x: e.pageX, y: e.pageY});
        // ($(document.elementsFromPoint(e.pageX,e.pageY)).filter('.'+this.s.type+'-table:not(.dt-rowReorder-float)').each(el=>{console.log($(el).attr('id'))}));

        // Transform the mouse position into a position in the table's body
        var top = this._eventToPage( e, 'Y' );// - this.s.bodyTop;



        if(top< this.s.bodyTop || top > this.s.bodyBottom){
            this._cachePositions(top);
        }

        var middles = this.s.middles;
        var insertPoint = null;
        var dt = this.s.dt;
        var bodyY = top - this.s.bodyTop;

        // Determine where the row should be inserted based on the mouse
        // position
        for ( var i=0, ien=middles.length ; i<ien ; i++ ) {
            if ( bodyY < middles[i] ) {
                insertPoint = i;
                break;
            }
        }

        if ( insertPoint === null ) {
            insertPoint = middles.length;
        }

        // Perform the DOM shuffle if it has changed from last time
        if ( this.s.lastInsert === null || this.s.lastInsert !== insertPoint ) {
            var nodes = $.unique( dt.rows( { page: 'current' } ).nodes().toArray() );

            if ( insertPoint > this.s.lastInsert && !$(nodes[insertPoint-1]).hasClass('shown')) {
                this.dom.target.insertAfter( nodes[ insertPoint-1 ] );
            }
            else if(!$(nodes[insertPoint]).hasClass('shown')) {
                this.dom.target.insertBefore( nodes[ insertPoint ] );
            }else if(middles.length == 0){
                this.dom.target.insert(dt.table().body());
            }

            this._cachePositions();

            this.s.lastInsert = insertPoint;
        }

        //this._shiftScroll( e );

    }


/**
 * Mouse up event handler - release the event handlers and perform the
 * table updates
 *
 * @param  {object} e Mouse event
 * @private
 */
    order.prototype._mouseUp = function ( e )
    {
        var that = this;
        var dt = this.s.dt;
        var i, ien;
        var dataSrc = this.c.dataSrc;

        // console.log('endtable',dt.table().node());

        this.s.moveObserver.complete();
        this.s.moveObserver = null;

        this.dom.clone.remove();
        this.dom.clone = null;

        this.dom.target.removeClass( 'dt-rowReorder-moving' );
        //this.dom.target = null;

        $(document).off( '.rowReorder' );
        $(document.body).removeClass( 'dt-rowReorder-noOverflow' );

        clearInterval( this.s.scrollInterval );
        this.s.scrollInterval = null;


        // Calculate the difference
        var startTable = this.s.start.table;
        var newTable = startTable.table().node() !== this.s.dt.table().node();
        var startNodes = newTable ? $.unique( dt.rows( { page: 'current' } ).nodes().toArray() ) : this.s.start.nodes;
        var endNodes = $.unique( dt.rows( { page: 'current' } ).nodes().toArray() );
        var idDiff = {};
        var fullDiff = [];
        var diffNodes = [];
        var getDataFn = this.s.getDataFn;
        var setDataFn = this.s.setDataFn;

        // console.log({
        //     end: endNodes,
        //     start: startNodes
        // });


        if(newTable){

            // console.log('new table',[startTable.table().node(),this.s.dt.table().node()]);

            //endNodes.splice(this.s.lastInsert,0,this.dom.target);

            for ( i=0, ien=endNodes.length ; i<ien ; i++ ) {

                var id = dt.row( endNodes[i] ).id();
                var endRowData = dt.row( endNodes[i] ).data();

                if ( id ) {
                    idDiff[ id ] = getDataFn( endRowData );
                }

                fullDiff.push({
                    node: endNodes[i],
                    newData: getDataFn( endRowData ),
                    oldData: getDataFn( endRowData ),
                    newPosition: i,
                    oldPosition: $.inArray( endNodes[i], endNodes ),
                })

                diffNodes.push(endNodes[i]);
            }

        }else{
            // console.log('old table');

            for ( i=0, ien=startNodes.length ; i<ien ; i++ ) {
                if ( startNodes[i] !== endNodes[i] ) {
                    var id = dt.row( endNodes[i] ).id();
                    var endRowData = dt.row( endNodes[i] ).data();
                    var startRowData = dt.row( startNodes[i] ).data();

                    if ( id ) {
                        idDiff[ id ] = getDataFn( startRowData );
                    }

                    fullDiff.push( {
                        changedTable: false,
                        node: endNodes[i],
                        oldData: getDataFn( endRowData ),
                        newData: getDataFn( startRowData ),
                        newPosition: i,
                        oldPosition: $.inArray( endNodes[i], startNodes )
                    } );

                    diffNodes.push( endNodes[i] );
                }
            }
        }

        let tableId = newTable ? ($(dt.table().node())) : null;

        // Create event args
        var eventArgs = [ fullDiff, {
            dataSrc:       dataSrc,
            nodes:         diffNodes,
            values:        idDiff,
            triggerRow:    newTable ? this.s.start.table.row(this.dom.target) : dt.row( this.dom.target ),
            newTable:      newTable,
            insertData:    newTable ? {order:this.dom.target.index(),table: tableId} : undefined,
            originalEvent: e
        } ];

        // Emit event
        this._emitEvent( 'row-reorder', eventArgs );

        var update = function () {
            if ( that.c.update ) {
                for ( i=0, ien=fullDiff.length ; i<ien ; i++ ) {
                    var row = dt.row( fullDiff[i].node );
                    var rowData = row.data();

                    setDataFn( rowData, fullDiff[i].newData );

                    // Invalidate the cell that has the same data source as the dataSrc
                    dt.columns().every( function () {
                        if ( this.dataSrc() === dataSrc ) {
                            dt.cell( fullDiff[i].node, this.index() ).invalidate( 'data' );
                        }
                    } );
                }

                // Trigger row reordered event
                that._emitEvent( 'row-reordered', eventArgs );

                dt.draw( false );


                if(newTable){
                    dt.ajax.reload();
                    startTable.ajax.reload();
                }
            }
        };

        // Editor interface
        if ( this.c.editor ) {
            // Disable user interaction while Editor is submitting
            this.c.enable = false;

            this.c.editor
                .edit(
                    diffNodes,
                    false,
                    $.extend( {submit: 'changed'}, this.c.formOptions )
                )
                .multiSet( dataSrc, idDiff )
                .one( 'preSubmitCancelled.rowReorder', function () {
                    that.c.enable = true;
                    that.c.editor.off( '.rowReorder' );
                    dt.draw( false );
                } )
                .one( 'submitUnsuccessful.rowReorder', function () {
                    dt.draw( false );
                } )
                .one( 'submitSuccess.rowReorder', function () {
                    update();
                } )
                .one( 'submitComplete', function () {
                    that.c.enable = true;
                    that.c.editor.off( '.rowReorder' );
                } )
                .submit();
        }
        else {
            update();
        }
    }
}
